import type { Address } from '@iheartjane/types';

export const getInitialDeliveryAddress = (
  deliveryAddress?: Partial<Address> | null
) => {
  return [
    deliveryAddress?.street?.trim() ?? '',
    deliveryAddress?.city?.trim() ?? '',
    deliveryAddress?.state_code?.trim() ?? '',
  ]
    .filter((str) => str.length > 0)
    .join(', ');
};
